import React, { useEffect } from 'react';

import { ReactNode } from 'react';

import HappyFaceSvg from 'App/assets/img/happy-face.svg?url';

import { ModalContainer } from '@welbe/web-design-system';

import { Container, Content, Title } from './ModalConfirm.styles';

type ModalConfirmProps = {
	onClose: () => void;
	imageUrl?: string;
	message?: string;
	children?: ReactNode;
	height?: string;
	width?: string;
	visible?: boolean;
	centralize?: boolean;
	hasCloseButton?: boolean;
	closeOnlyOnTheButton?: boolean;
};

export const ModalConfirm = ({
	onClose,
	imageUrl,
	message,
	children,
	height = '25vh',
	width,
	centralize,
	hasCloseButton = true,
	closeOnlyOnTheButton = true,
	visible = true,
}: ModalConfirmProps): JSX.Element => {
	useEffect(() => {
		if (!visible) return;
		const timeoutId = setTimeout(() => {
			onClose();
		}, 4000);

		return () => clearTimeout(timeoutId);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [visible]);

	return (
		<ModalContainer
			visible={visible}
			height={height}
			zIndex={1400}
			closeOnlyOnTheButton={closeOnlyOnTheButton}
			hasCloseButton={hasCloseButton}
			onClose={onClose}
			width={width}
		>
			<Container>
				<Content>
					<img src={imageUrl || HappyFaceSvg} alt="Modal Confirm" />
					<Title centralize={centralize}>{message || '¡Sucesso!'}</Title>
					{children}
				</Content>
			</Container>
		</ModalContainer>
	);
};
